//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { AXIOS } from '../../axios/axios.js'

export default {
  data () {
    return {
      showViewer: false,
      htmlOutput: null,
      downloadUrl: null,
      loading: false,
      viewerFrame: null
    }
  },
  beforeDestroy: function () {
    this.viewerFrame.contentWindow.removeEventListener('resize', this.styleIframe)
  },
  methods: {
    afterCreated: function () {
      console.log('DOCX viewer: created')
      this.visible = true
    },
    getFileHtmlOrText: async function (id, type) {
      let file = null

      await AXIOS({
        method: 'get',
        url: '/service/fileobj/content/' + id + (type === 'doc' ? '?convert=html' : '')
      }).then(async response => {
        file = response.data // new File ([response.data], this.getFileName(response))
      }).catch(error => {
        this.$q.notify({
          type: 'warning',
          message: 'Не удалось загрузить файл, ' + error.message,
          progress: true,
          timeout: 8000
        })
      })
      return file
    },
    getFileName: function (response) {
      try {
        const headerLine = response.headers['content-disposition']
        const startFileNameIndex = headerLine.indexOf('"') + 1
        const endFileNameIndex = headerLine.lastIndexOf('"')
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex)
        filename = decodeURI(filename)
        return filename
      } catch {
        return undefined
      }
    },
    downloadFile: async function () {
      const link = document.createElement('a')
      link.href = this.downloadUrl
      link.click()
    },
    onLoadContent: function (e) {
      this.viewerFrame = e.target
      if (this.viewerFrame.contentWindow.location.href != 'about:blank') {
        this.viewerFrame.contentWindow.addEventListener('resize', this.styleIframe)
        this.styleIframe()
        // this.setAdaptiveFontSize()
      }
    },
    styleIframe: function (e) {
      this.viewerFrame.style.padding = '0'
      this.viewerFrame.style.width = '100%'
      this.viewerFrame.style.height = this.viewerFrame.contentWindow.document.body.scrollHeight + 100 + 'px'
      this.viewerFrame.style.margin = 0
      // this.viewerFrame.style.boxSizing = 'border-box'
      // const contentWidth = this.viewerFrame.contentWindow.document.body.offsetWidth
      // this.viewerFrame.contentWindow.document.getElementsByTagName('html')[0].style.fontSize = 3 * Math.log(contentWidth - 200) + 'px' // empirical dependency for smoother font resizing based on width
    },
    setAdaptiveFontSize: function () {
      const bodyEl = this.viewerFrame.contentWindow.document.body
      const bodyStyles = this.viewerFrame.contentWindow.getComputedStyle(bodyEl)
      const rootFontSize = parseFloat(bodyStyles.getPropertyValue('font-size'))

      const marginTop = bodyStyles.getPropertyValue('margin-top')
      const marginRight = bodyStyles.getPropertyValue('margin-right')
      const marginBottom = bodyStyles.getPropertyValue('margin-bottom')
      const marginLeft = bodyStyles.getPropertyValue('margin-left')
      const width = 1100 // max width of docx-view

      bodyEl.style.marginTop = 0 + 'px'
      bodyEl.style.marginRight = 0 + 'px'
      bodyEl.style.marginBottom = 0 + 'px'
      bodyEl.style.marginLeft = 0 + 'px'

      // all padding values set in % take as 100% width of container
      bodyEl.style.paddingTop = parseFloat(marginTop) / width * 100 + '%'
      bodyEl.style.paddingRight = parseFloat(marginRight) / width * 100 + '%'
      bodyEl.style.paddingBottom = parseFloat(marginBottom) / width * 100 + '%'
      bodyEl.style.paddingLeft = parseFloat(marginLeft) / width * 100 + '%'

      const elements = this.viewerFrame.contentWindow.document.querySelectorAll('*')
      bodyEl.style.fontSize = rootFontSize + 'px'
      for (let i = 0; i < elements.length; i++) {
        // console.log(elements[i])
        const element = elements[i]
        const styles = this.viewerFrame.contentWindow.getComputedStyle(element)
        const elementFontSize = parseFloat(styles.getPropertyValue('font-size'))
        element.style.fontSize = (rootFontSize / elementFontSize) + 'rem'
      }
    },
    show: function (file) {
      this.loading = true
      this.downloadUrl = file.url
      this.getFileHtmlOrText(file.id, (file.contentType === 'application/msword' || file.contentType.includes('officedocument')) ? 'doc' : 'txt').then(resultFile => {
        this.htmlOutput = '<div>' + resultFile + '</div>'
      }).finally(() => {
        this.loading = false
      })
      this.showViewer = true
    },
    hide: function () {
      this.showViewer = false
      this.htmlOutput = null
    }
  }
}
